import { render, staticRenderFns } from "./SWSBreadcrumb.vue?vue&type=template&id=c2ccd2cc&scoped=true&"
import script from "./SWSBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./SWSBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./SWSBreadcrumb.vue?vue&type=style&index=0&id=c2ccd2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ccd2cc",
  null
  
)

export default component.exports